export const WIDTH = 230;
export const DEFAULT_HEX_COLOR = '#ffffffff';

export const DEFAULT_PRESET_COLORS = [
  '#D0021BFF',
  '#F5A623FF',
  '#F8E71CFF',
  '#8B572AFF',
  '#7ED321FF',
  '#417505FF',
  '#BD10E0FF',
  '#9013FEFF',
  '#4A90E2FF',
  '#50E3C2FF',
  '#B8E986FF',
  '#000000FF',
  '#4A4A4AFF',
  '#9B9B9BFF',
  '#FFFFFFFF',
];
